
export default {
  props: {
    pageContent: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      scrollOptions: {
        duration: 1000,
        offset: 0,
        easing: 'easeInOutCubic'
      }
    }
  },
  methods: {
    externalLink (linkURL) {
      window.open(linkURL, '_blank') // to open in new tab
    }
  }
}
